import a from "react";
import l from "@appchoose/cn";
const o = ({
  appearance: e = "default",
  value: r,
  ...t
}) => /* @__PURE__ */ a.createElement("div", { className: "flex h-2 overflow-hidden rounded-full bg-gray-300" }, /* @__PURE__ */ a.createElement(
  "div",
  {
    role: "progressbar",
    style: { width: `${r}%` },
    "aria-valuenow": r,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    className: l(
      "ease flex justify-center overflow-hidden rounded-full bg-gray-900 text-center transition-all duration-500",
      {
        "bg-green-900": e === "success",
        "bg-orange-600": e === "warning",
        "bg-red-600": e === "error"
      }
    ),
    ...t
  }
));
o.displayName = "ProgressBar";
export {
  o as default
};
